import React, { useContext, useEffect, useState } from "react";
import "../styles/basketItemDiscount.css";
import "../styles/summary.css";
import { useDispatch, useSelector } from "react-redux";
import { removeFromRemovableCoupons } from "../store/couponsSlice";
import { basketActions } from "../store/basket";
import { loaderActions } from "../store/loaderSlice";
import { footerActions } from "../store/footerSlice";
import { couponsActions } from "../store/couponsSlice";
import appConst from "../Utilities/appConst.json";
import { LanguageContext } from "../context/language/LanguageContext";
import { alertActions } from "../store/alertSlice";
import { useHistory, useLocation } from "react-router-dom";

export default function UncombinededCoupon(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const languageContext = useContext(LanguageContext);

  const basket = useSelector((state) => state.basket.basket);
  const selectedId = useSelector((state) => state.shipping.selectedId);
  const isCollectionBucketCouponFromShipping = useSelector(
    (state) => state.coupons.isCollectionBucketCouponFromShipping
  );
  const selectedShippingMethod = useSelector(
    (state) => state.shipping.selectedShippingMethod
  );
  const isNewsletter = useSelector((state) => state.user.isNewsletter);
  const direction = useSelector((state) => state.mode.direction);

  const [shouldDelete, setShouldDelete] = useState(false);
  const title = `${props.coupon.coupon_name}- ${props.coupon.title}`;
  const couponId = props.coupon?.coupon_id ?? "unknown";

  useEffect(() => {
    if (shouldDelete) {
      const basketWithShipping = isCollectionBucketCouponFromShipping
        ? basket
        : {
            ...basket,
            delivery_details: {
              ...basket.delivery_details,
              delivery_type: selectedId,
            },
          };

      // if collection bucket and shipping method are not selected, isCollectionBucketCoupon send as true
      dispatch(
        removeFromRemovableCoupons(
          props.coupon,
          basketWithShipping,
          isCollectionBucketCouponFromShipping
        )
      );

      // if collection bucket and shipping method are not selected, go back to shipping page
      if (isCollectionBucketCouponFromShipping) {
        dispatch(couponsActions.setIsCollectionBucketCouponFromShipping(false));
        historyBackToShippingPage();
      }

      dispatch(loaderActions.loaderShow());
      setShouldDelete(false);
    }
  }, [shouldDelete]);

  const historyBackToShippingPage = () => {
    history.push({
      pathname: appConst.FIFTH_PAGE,
      search: location.search,
    });
  };

  const alertSelectedYes = () => {
    setShouldDelete(true);
  };

  const hendleOnClick = () => {
    const isCollectionBucketCoupon = !!(
      props.coupon.collection_bucket_name &&
      props.coupon.collection_bucket_message
    );

    // if collection bucket and shipping method is not selected, pop up alert
    if (isCollectionBucketCouponFromShipping) {
      dispatch(
        alertActions.createAlert({
          title: languageContext.getTranslation(appConst.EXCUSE_ME),
          message: languageContext.getTranslation(
            appConst.ALERT_COLLECTION_BUCKET_REMOVE_MESSAGE
          ),
          funcYes: alertSelectedYes,
          yesButtonText: appConst.BRING_ME_BACK,
          noButtonText: appConst.KEEP_ME_CONNECTED,
          isInput: false,
          isDialog: true,
        })
      );
    }
    // else, if collection bucket and shipping method is selected, get the previous shipping method
    else if (isCollectionBucketCoupon) {
      setShouldDelete(true);

      // Before deleting the coupon - update the basket
      dispatch(basketActions.setDeliveryDetailsType({ id: selectedId }));
      dispatch(
        footerActions.setFooterShippingFromUpdateCoupons(
          isNewsletter
            ? selectedShippingMethod.priceForClubMember
            : selectedShippingMethod.price
        )
      );
    } else {
      dispatch(loaderActions.loaderShow());
      dispatch(removeFromRemovableCoupons(props.coupon, basket));
    }
  };

  return (
    <div
      className="position_flex_row_space_between"
      style={{ padding: "6px 9px" }}
      data-testid={`summary-service-coupon-${couponId}`}
    >
      <div className="summary_Removable_coupon_and_icon1">
        <div className="summary_box_item">
          <div className="bold" style={{ direction, textAlign: "start" }}>
            {title}
          </div>
        </div>
      </div>
      <div
        className="item_clickabule color_green"
        onClick={hendleOnClick}
        style={{ paddingInlineStart: "1vw" }}
        data-testid={`summary-coupon-remove-${couponId}`}
      >
        {languageContext.getTranslation(appConst.REMOVE)}
      </div>
    </div>
  );
}
